(function ($) {
    'use strict';

    // Track if a token refresh is already in progress
    let tokenRefreshPromise = null;

    // Function to refresh the antiforgery token
    function refreshAntiforgeryToken() {
        if (tokenRefreshPromise) {
            // If a refresh is already in progress, return the existing promise
            return tokenRefreshPromise;
        }

        tokenRefreshPromise = $.ajax({
            url: "/antiforgery/refresh",
            type: "GET",
            cache: false
        }).then(function(data) {
            // Update all antiforgery tokens in the page
            $('input[name="__RequestVerificationToken"]').val(data.token);

            // Also update the meta tag if you're using it for AJAX
            $('meta[name="__RequestVerificationToken"]').attr('content', data.token);

            return data.token;
        }).always(function() {
            // Clear the promise when done so future requests can refresh again
            tokenRefreshPromise = null;
        });

        return tokenRefreshPromise;
    }

    // Global AJAX prefilter for all POST, PUT, PATCH, DELETE requests
    $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
        const method = options.type ? options.type.toUpperCase() : 'GET';

        // Only intercept requests that should have antiforgery tokens
        if (['POST', 'PUT', 'PATCH', 'DELETE'].indexOf(method) !== -1) {
            // Store the original beforeSend callback
            const originalBeforeSend = options.beforeSend;

            // Flag to track if we've already modified this request
            if (options._antiforgeryProcessed) {
                return;
            }
            options._antiforgeryProcessed = true;

            // Override beforeSend to refresh token first
            options.beforeSend = function(xhr, settings) {
                // Create a deferred object to handle async token refresh
                const dfd = $.Deferred();

                refreshAntiforgeryToken().done(function(token) {
                    // Update the data if it's being sent as a serialized string
                    if (typeof settings.data === 'string' && settings.data.indexOf('__RequestVerificationToken') !== -1) {
                        const params = new URLSearchParams(settings.data);
                        params.set('__RequestVerificationToken', token);
                        settings.data = params.toString();
                    }

                    // Update FormData if that's what's being sent
                    if (settings.data instanceof FormData) {
                        settings.data.set('__RequestVerificationToken', token);
                    }

                    // Call the original beforeSend if it exists
                    let result = true;
                    if (originalBeforeSend) {
                        result = originalBeforeSend.call(this, xhr, settings);
                    }

                    dfd.resolve(result);
                }).fail(function(error) {
                    console.error('Failed to refresh antiforgery token:', error);
                    dfd.reject(error);
                });

                return dfd.promise();
            };
        }
    });

    // Also refresh token when the page gains focus (user switches back to this tab)
    $(window).on('focus', function() {
        refreshAntiforgeryToken();
    });

    console.log('Antiforgery token auto-refresh initialized');

})(jQuery);